import { render, staticRenderFns } from "./QuoteExtraItemsSection.vue?vue&type=template&id=6c06d3f8&"
import script from "./QuoteExtraItemsSection.vue?vue&type=script&lang=ts&"
export * from "./QuoteExtraItemsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports